import { generateLiningsGradient } from 'src/util/canvas'
import { topSidePartOfWeb } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const w1Web = async (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  laceColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'

  // ウェブ本体
  const drawMainPath = () => {
    ctx.beginPath()
    ctx.moveTo(300, 376) // 左下
    ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
    ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
    ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
    ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  const coordinates = { x0: 208, y0: 75, x1: 349, y1: 396 }
  const gradient = generateLiningsGradient(ctx, webColor, coordinates, 0.12)
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawMainPath, gradient as unknown as string)
  // 内側のライン
  ctx.beginPath()
  ctx.moveTo(334, 318) // 左下
  ctx.quadraticCurveTo(312, 266, 298, 210) // 上
  ctx.quadraticCurveTo(320, 255, 336, 314) // 右下
  ctx.stroke()
  ctx.closePath()

  // ウェブ先端
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // デザイン左＿外
  ctx.moveTo(330, 317) // 下
  ctx.quadraticCurveTo(309, 270, 293, 208) // 上1
  ctx.quadraticCurveTo(298, 203, 298, 205) // 上2
  ctx.quadraticCurveTo(323, 252, 338, 307) // 下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()

  // lace
  laceOfAllowLiningRight(ctx, laceColor, -27, -75)
  laceOfAllowLiningRight(ctx, laceColor, -21, -60)
  laceOfAllowLiningRight(ctx, laceColor, -15, -45)
  laceOfAllowLiningRight(ctx, laceColor, -10, -30)
  laceOfAllowLiningRight(ctx, laceColor, -5, -15)
  laceOfAllowLiningRight(ctx, laceColor, 0, 0)

  laceOfAllowLiningLeft(ctx, laceColor, -25, -75)
  laceOfAllowLiningLeft(ctx, laceColor, -20, -60)
  laceOfAllowLiningLeft(ctx, laceColor, -15, -45)
  laceOfAllowLiningLeft(ctx, laceColor, -10, -30)
  laceOfAllowLiningLeft(ctx, laceColor, -5, -15)
  laceOfAllowLiningLeft(ctx, laceColor, 0, 0)
  ctx.beginPath()
  ctx.moveTo(289, 210)
  ctx.quadraticCurveTo(287, 214, 291, 218)
  ctx.quadraticCurveTo(305, 204, 305, 204)
  ctx.quadraticCurveTo(306, 197, 302, 197)
  ctx.quadraticCurveTo(289, 210, 289, 210)
  ctx.fill()
  ctx.moveTo(290, 216)
  ctx.quadraticCurveTo(305, 200, 305, 202)
  ctx.stroke()
  ctx.closePath()
}

const laceOfAllowLiningRight = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(326 + x, 291 + y) // 左上
  ctx.quadraticCurveTo(330 + x, 299 + y, 330 + x, 299 + y) // 左下
  ctx.quadraticCurveTo(343 + x, 298 + y, 343 + x, 298 + y) // 右下
  ctx.quadraticCurveTo(345 + x, 291 + y, 341 + x, 291 + y) // 右上
  ctx.quadraticCurveTo(326 + x, 291 + y, 326 + x, 291 + y) // 左下
  ctx.fill()
  ctx.moveTo(330 + x, 297 + y) // 左下
  ctx.quadraticCurveTo(343 + x, 296 + y, 343 + x, 298 + y) // 右下
  ctx.stroke()
  ctx.closePath()
}

const laceOfAllowLiningLeft = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = laceColor
  ctx.beginPath()
  ctx.moveTo(321 + x, 306 + y) // 左上
  ctx.quadraticCurveTo(324 + x, 313 + y, 324 + x, 313 + y) // 左下
  ctx.quadraticCurveTo(329 + x, 307 + y, 331 + x, 301 + y) // 右下
  ctx.quadraticCurveTo(328 + x, 298 + y, 328 + x, 298 + y) // 右上
  ctx.quadraticCurveTo(321 + x, 306 + y, 321 + x, 306 + y) // 左下
  ctx.fill()
  ctx.moveTo(324 + x, 311 + y) // 左下
  ctx.quadraticCurveTo(327 + x, 305 + y, 331 + x, 300 + y) // 右下
  ctx.stroke()
  ctx.closePath()
}
